import BaseLoLLayout from './BaseLoLLayout';

export default BaseLoLLayout;
